module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user.user_nicename) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.isLoading) ? _c('div', {
    attrs: {
      "id": "loading"
    }
  }, [_c('orbit-spinner', {
    attrs: {
      "animation-duration": 1200,
      "size": 55,
      "color": "#24890d"
    }
  })], 1) : _vm._e(), _c('h1', [_vm._v("Ansergy Email Reports")]), _c('h3', [_vm._v(_vm._s(_vm.user.user_nicename))]), _c('br'), _c('report-template-list')], 1) : _c('div', {
    attrs: {
      "id": "loading"
    }
  }, [_c('h4', [_vm._v("Loading ...")]), _c('orbit-spinner', {
    attrs: {
      "animation-duration": 1200,
      "size": 55,
      "color": "#24890d"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20c9a2f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 258
// module chunks = 1